import { z } from 'zod'
import { Identity } from '~library/enums'
import { enumWithEmpty } from '~library/models'

/** 使用者資訊(Basic) Schema */
export const basicUserProfileSchema = z.object({
  /** 會員卡號 */
  memberCardNumber: z.string(),
  /** 身份 */
  identity: z.enum(Identity),
  /** 會員姓名 */
  name: z.string(),
  /** 會員英文姓名 */
  englishName: z.string(),
  /** 企業代碼 */
  bizId: z.string(),
  /** 客戶名稱 */
  corporateLocalName: z.string(),
  /** 客戶英文名稱 */
  corporateEnglishName: z.string(),
  /** 是否已綁定企業會員 */
  binding: z.boolean(),
  /** 是否已同意條款 */
  agreeTerms: z.boolean(),
  /** 場站 */
  station: z.string(),
  /** email */
  email: z.string(),
  /** JWT token */
  token: z.string().optional(),
  /** refresh token */
  refreshToken: z.string().optional()
})

/** 使用者資訊 Schema */
export const userProfileSchema = basicUserProfileSchema.extend({
  /** 身份 兼容空字串 */
  identity: enumWithEmpty(Identity),
  /** 錯誤次數 */
  errorCount: z.number(),
  /** OTP剩餘時間 */
  otpRemainingTime: z.number(),
  /** sseCode */
  sseCode: z.string(),
  /** 裝置Token	 */
  deviceToken: z.string().optional()
})

/** 使用者資訊(簡易版)(sso登入使用) */
export interface BasicUserProfile
  extends z.infer<typeof basicUserProfileSchema> {}

/** 使用者資訊 */
export interface UserProfile extends z.infer<typeof userProfileSchema> {}
